import React from "react";
import { FormRuntime } from "../../FormRuntime";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";
import { FormConfiguration } from "../../FormConfiguration";

export const ButtonGroupStories = [
    new StoryNode(
        () => {
            let ui = new FormConfiguration();
            return <FormRuntime form={ui}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "Button Group - MISSING"
    ),
];
